/** Workshop module labels for Prompt Manager (matches prompt_templates.category). */
export const MODULE_LABELS = {
  solutions: 'Ratkaisut',
  impact_path: 'Vaikutuspolut',
  lenses: 'Linssit',
  pivot_points: 'Vipupisteet',
  report: 'Raportti',
  chat: 'Chat',
  indexing: 'Indeksointi',
  rag: 'RAG',
  system: 'Järjestelmä',
};

export function getModuleLabel(category) {
  return MODULE_LABELS[category] || category || '—';
}
